__turbopack_context__.v({
  "label": "i_IjsW_label",
});
